import { render, staticRenderFns } from "./ZoomButtons.vue?vue&type=template&id=9f2fa13c&"
import script from "./ZoomButtons.vue?vue&type=script&lang=ts&"
export * from "./ZoomButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports